import React from "react";
import { useQuery } from "convex/react";
import { api as convexApi } from "../../lib/convexApi";

function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

/**
 * Admin-only cost dashboard tab. Reads from `convex/admin/usage.ts`
 * (`requireOrg({ plan: "security", role: "admin" })`-gated). The
 * underlying query currently returns placeholder zeros for storage /
 * bandwidth / fn-call counts — production hook into Convex's billing
 * API is deferred to a follow-up spec (requires team API key + cron).
 *
 * Spec 5 PR 10 — Task 75.
 */
export function CostDashboardTab() {
  const usage = useQuery(convexApi.admin.usage.summary, {});
  if (!usage) return <div className="loading">Loading cost dashboard…</div>;
  return (
    <section className="admin-tab cost-dashboard">
      <header className="admin-tab-header admin-pane__head">
        <div>
          <h2>Cost dashboard</h2>
          <p className="muted-fg">
            Convex deployment usage. Billing API integration ships in a follow-up spec; the values
            below are placeholders for the tier currently in effect.
          </p>
        </div>
        <span className="tier-chip admin-chip">Tier: {usage.currentTier}</span>
      </header>
      <div className="usage-grid admin-dashboard-grid">
        <article className="usage-card admin-metric-card">
          <span>Function calls this month</span>
          <strong className="usage-value">{usage.fnCallsThisMonth.toLocaleString()}</strong>
        </article>
        <article className="usage-card admin-metric-card">
          <span>Storage</span>
          <strong className="usage-value">{formatBytes(usage.storageBytes)}</strong>
        </article>
        <article className="usage-card admin-metric-card">
          <span>Bandwidth</span>
          <strong className="usage-value">{formatBytes(usage.bandwidthBytes)}</strong>
        </article>
      </div>
    </section>
  );
}
